import { z } from 'zod';

import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodPappersLegalInfo = z
  .object({
    name: ZodTrimmedString.nullable(),
    date_of_birth: ZodTrimmedString.nullable(),
    age: z.number().nullable(),
    location: ZodTrimmedString.nullable(),
    citizenship: ZodTrimmedString.nullable(),
    gender: ZodTrimmedString.nullable(),
    place_of_birth: ZodTrimmedString.nullable(),
  })
  .partial();
